import { render, staticRenderFns } from "./editCar.vue?vue&type=template&id=38efcda8"
import script from "./editCar.vue?vue&type=script&lang=js"
export * from "./editCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports